/*
Saldo de destacados de ChileAutos y aplicar/quitar destacados en un aviso.

El saldo se pide siempre en vivo (la API no lo cachea): los concesionarios
también gastan cupos desde el portal de ChileAutos.
*/
import { useCallback, useState } from 'react'

import { customFetch, customPost } from '../utils/customFetch.ts'

import { makeUrlChaProducts, makeUrlChaVehicleTags } from './connectionData.tsx'

import type { ChaProduct, ChaRequestedTag, ChaVehicleTagsResult } from '../interfaces/ChaProducts.ts'

const errorOf = (err: unknown) => (err instanceof Error ? err : new Error('Error desconocido'))

const useChaProducts = () => {
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false)
  const [applying, setApplying] = useState<boolean>(false)

  const chaProductsGet = useCallback(async (organizationId: string): Promise<ChaProduct[]> => {
    setLoadingProducts(true)

    try {
      const res = await customFetch<{ products: ChaProduct[] }>(makeUrlChaProducts(organizationId))

      return res.products
    } catch (err) {
      throw errorOf(err)
    } finally {
      setLoadingProducts(false)
    }
  }, [])

  /*
  `tags` es la lista COMPLETA que tiene que quedar en el aviso (`[]` quita todo).
  La API puede tardar hasta ~30 s: confirma contra el saldo de ChileAutos.
  */
  const chaVehicleTags = useCallback(
    async (vehicleId: string, tags: ChaRequestedTag[], confirmConsumable: boolean): Promise<ChaVehicleTagsResult> => {
      setApplying(true)

      try {
        return await customPost<ChaVehicleTagsResult>(makeUrlChaVehicleTags(), { vehicleId, tags, confirmConsumable })
      } catch (err) {
        throw errorOf(err)
      } finally {
        setApplying(false)
      }
    },
    []
  )

  return { loadingProducts, applying, chaProductsGet, chaVehicleTags }
}

export default useChaProducts
